import { defineComponent as s, openBlock as a, createElementBlock as n, normalizeClass as e, createElementVNode as o, normalizeStyle as t } from "vue";
import { _ as i } from "../../../_plugin-vue_export-helper-dad06003.js";
const p = s({
  name: "VProgressBar",
  props: {
    size: {
      type: String,
      default: "s",
      validator: (r) => ["s", "xs"].indexOf(r) !== -1
    },
    color: {
      type: String,
      default: "orange",
      validator: (r) => ["green", "orange"].indexOf(r) !== -1
    },
    progress: {
      type: Number,
      default: 0,
      validator: (r) => r >= 0 && r <= 100
    }
  },
  computed: {
    showFragment() {
      return this.progress > 0 && this.progress < 100 && this.color === "orange";
    }
  }
});
function l(r, g, d, c, _, m) {
  return a(), n("div", {
    class: e(["hobi-progress-bar", ["hobi-progress-bar--size-" + r.size]])
  }, [
    o("div", {
      class: e(["hobi-progress-bar__done", ["hobi-progress-bar--color-" + r.color]]),
      style: t({ width: `${r.progress}%` })
    }, null, 6),
    o("div", {
      class: e(["hobi-progress-bar__remaining", { "hobi-progress-bar__remaining-fragment": r.showFragment }])
    }, null, 2)
  ], 2);
}
const b = /* @__PURE__ */ i(p, [["render", l], ["__scopeId", "data-v-552ace46"]]);
export {
  b as default
};
